import { Link } from 'react-router-dom';

export default function ContactCTA() {
  return (
    <section id="contact-section" className="py-24 bg-[#f6f7f8]">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#2a4b7c] leading-tight mb-6">
          Sẵn sàng bắt đầu chuyển đổi số một cách{' '}
          <span className="text-cyan-500 underline decoration-2 underline-offset-2">
            đúng đắn
          </span>{' '}
          và{' '}
          <span className="text-cyan-500 underline decoration-2 underline-offset-2">
            an toàn
          </span>
          .
        </h2>
        <p className="text-lg text-gray-600 mb-10 max-w-2xl mx-auto">
          Kết nối với các chuyên gia cấp cao của chúng tôi để bắt đầu đánh giá
          hiện trạng cơ sở hạ tầng của bạn ngay hôm nay.
        </p>
        <Link
          to="/lien-he"
          className="inline-flex items-center justify-center px-8 py-4 bg-[#2a4b7c] text-white font-bold text-sm uppercase tracking-wide rounded-lg shadow-md hover:bg-[#1e3557] hover:shadow-lg transition-all duration-300"
        >
          Yêu cầu tư vấn trực tiếp
        </Link>
      </div>
    </section>
  );
}
